import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import HSALogo from './ui/HSALogo';
import BrandBand from './ui/BrandBand';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActiveRoute = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  // Simplified navigation - single line, no dropdowns
  const navigationItems = [
    { name: 'Accueil', path: '/' },
    { name: 'Services', path: '/services' },
    { name: 'À Propos', path: '/a-propos' },
    { name: 'Envie d\'un véhicule?', path: '/contact' }
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-black/95 backdrop-blur-sm border-b border-white/10' 
          : 'bg-transparent'
      }`}
    >
      {/* Subtle Brand Band */}
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-6">
        <div className="flex items-center justify-between h-14 sm:h-16 md:h-18">
          {/* Logo - Primary Version */}
          <Link to="/" className="flex items-center group">
            <HSALogo variant="primary" size="xlarge" className="group-hover:opacity-80 transition-opacity duration-300" />
          </Link>

          {/* Clean Navigation - Responsive */}
          <nav className="hidden lg:flex items-center space-x-8 lg:space-x-10">
            {navigationItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`font-medium text-sm transition-colors duration-200 ${
                  isActiveRoute(item.path)
                    ? 'text-[#BFC50D]'
                    : 'text-white/80 hover:text-white'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Clean Contact Info - Responsive */}
          <div className="hidden lg:flex items-center">
            <a
              href="tel:+33646599430"
              className="flex items-center space-x-2 text-white/70 hover:text-[#BFC50D] transition-colors duration-200"
            >
              <Phone className="w-4 h-4" />
              <span className="text-sm font-medium">+33 6 46 59 94 30</span>
            </a>
          </div>

          {/* Clean Mobile Menu Button - Responsive */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 bg-white/5 rounded-lg flex items-center justify-center border border-white/10 hover:border-white/20 transition-colors duration-200"
          >
            {isMobileMenuOpen ? (
              <X className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
            ) : (
              <Menu className="w-4 h-4 sm:w-5 sm:h-5 text-white" />
            )}
          </button>
        </div>
      </div>

      {/* Clean Mobile Menu - Responsive */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-black/95 backdrop-blur-sm border-b border-white/10">
          <div className="px-3 sm:px-4 py-4 sm:py-6 space-y-1 sm:space-y-2">
            {navigationItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-2 sm:py-3 px-3 sm:px-4 rounded-lg font-medium transition-colors duration-200 ${  
                  isActiveRoute(item.path)
                    ? 'text-[#BFC50D] bg-[#BFC50D]/10'
                    : 'text-white/80 hover:text-white hover:bg-white/5'
                }`}
              >
                {item.name}
              </Link>
            ))}
            
            {/* Mobile Contact */}
            <div className="pt-3 sm:pt-4 border-t border-white/10">
              <a
                href="tel:+33646599430"
                className="flex items-center space-x-2 sm:space-x-3 py-2 sm:py-3 px-3 sm:px-4 rounded-lg text-white/80 hover:text-white hover:bg-white/5 transition-colors duration-200"
              >
                <Phone className="w-4 h-4" />
                <span className="font-medium">+33 6 46 59 94 30</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;